import Input from './components/input'
import ButtonModel from './components/buttonModel'
import WflDemo from './components/wfl-demo'

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}

function install (Vue) {
  Vue.component(Input.name, Input)
  Vue.component(ButtonModel.name, ButtonModel)
  Vue.component(WflDemo.name, WflDemo)
}

export default {
  install,
  Input,
  ButtonModel,
  WflDemo
}



// WEBPACK FOOTER //
// ./src/index.js